import React from "react"
import { useQuery } from "@tanstack/react-query"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { DataTable, ColumnHelper } from "@/components/data-table"
import { api } from "@/lib/api"
import { FileText, RefreshCw } from "lucide-react"

export default function LogsPage() {
  const [actionFilter, setActionFilter] = React.useState("")
  const [moduleFilter, setModuleFilter] = React.useState("")

  const params = React.useMemo(() => {
    const p = {}
    if (actionFilter) p.action = actionFilter
    if (moduleFilter) p.module = moduleFilter
    return p
  }, [actionFilter, moduleFilter])

  const { data, isLoading, refetch } = useQuery({
    queryKey: ["audit-logs", params],
    queryFn: () => api.getAuditLogs(params),
  })

  const colHelper = ColumnHelper()
  const columns = React.useMemo(
    () => [
      colHelper.text("id", { label: "ID" }),
      colHelper.text("user_id", { label: "User" }),
      colHelper.text("action", { label: "Action" }),
      colHelper.text("module", { label: "Module" }),
      colHelper.text("details", { label: "Details" }),
      colHelper.date("created_at", { label: "Time" }),
    ],
    []
  )

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <FileText className="h-8 w-8 text-muted-foreground" />
          <div>
            <h1 className="text-3xl font-bold tracking-tight">Audit Logs</h1>
            <p className="text-muted-foreground">System audit trail</p>
          </div>
        </div>
        <Button variant="outline" onClick={() => refetch()}>
          <RefreshCw className="mr-2 h-4 w-4" />
          Refresh
        </Button>
      </div>

      <div className="flex items-center gap-3">
        <Input
          placeholder="Filter by action..."
          value={actionFilter}
          onChange={(e) => setActionFilter(e.target.value)}
          className="w-48"
        />
        <Select value={moduleFilter} onValueChange={setModuleFilter}>
          <SelectTrigger className="w-48">
            <SelectValue placeholder="All modules" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All modules</SelectItem>
            <SelectItem value="user">User</SelectItem>
            <SelectItem value="config">Config</SelectItem>
            <SelectItem value="pricing">Pricing</SelectItem>
            <SelectItem value="panel">Panel</SelectItem>
            <SelectItem value="cache">Cache</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <DataTable
        columns={columns}
        data={data?.data || []}
        searchKey="action"
        searchPlaceholder="Search logs..."
        onRefresh={refetch}
        isLoading={isLoading}
        emptyMessage="No audit logs found"
      />
    </div>
  )
}
